import { Grid, Typography } from '@mui/material';
import { ObjectFieldTemplateProps } from '@rjsf/core';

export default function GridTemplate({ title, properties, uiSchema }: ObjectFieldTemplateProps) {
  return (
    <div>
      {title && (
        <Typography variant="h4" sx={{ mb: 3 }}>
          {title}
        </Typography>
      )}
      <Grid container spacing={3}>
        {properties.map((property) => (
          <Grid key={property.name} item xs={12} sm={uiSchema?.[property.name]?.['ui:column'] ? uiSchema[property.name]['ui:column'] : 12}>
            {property.content}
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
